import { withPrefix } from 'gatsby'
import WordData from '../../utils/WordData'
const ASSETS_BASE_URL = withPrefix('/phaser/images/bathroom')

export const BACKGROUND_CONTEXT = ASSETS_BASE_URL + '/background.png'
const argentis = process.env.LOCALE === 'es-arg';

// CAMBIA TUS PROTECTORES 3 VECES AL DÍA PARA MAYOR PROTECCIÓN
export const WORD_LIST_1 = [
  {
    stickPosX: 127.5,
    stickPosY: 378.4,
    word: argentis ? 'cambiá' : 'cambia',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + `/set1/${argentis ? 'cambia_arg' : 'cambia'}.png`,
  }, {
    stickPosX: 926.5,
    stickPosY: 388.4,
    word: 'tus',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/tus.png',
  }, {
    stickPosX: 291.5,
    stickPosY: 405,
    word: 'protectores',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/protectores.png',
  }, {
    stickPosX: 690,
    stickPosY: 250,
    word: '3',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/3.png',
  }, {
    stickPosX: 820,
    stickPosY: 431,
    word: 'veces',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/veces.png',
  }, {
    stickPosX: 82.5,
    stickPosY: 453.48,
    word: 'al',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/al.png',
  }, {
    stickPosX: 112,
    stickPosY: 193,
    word: 'dia',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/dia.png',
  }, {
    stickPosX: 1097,
    stickPosY: 269,
    blendType: "normal",
    word: 'para',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/para.png',
  }, {
    stickPosX: 535,
    stickPosY: 139,
    blendType: "normal",
    word: 'mayor',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/mayor.png',
  }, {
    stickPosX: 571,
    stickPosY: 449,
    blendType: "normal",
    word: 'protección',
    isLocked: false,
    stickSrc: ASSETS_BASE_URL + '/set1/proteccion.png',
  }]
  .map((data) => new WordData(data));



/// VERSION 2 :USA JABÓN ÍNTIMO Y MANTÉN BALANCEADO EL PH DE TU ZONA V
export const WORD_LIST_2 = [
  {
    "stickPosX": 685.89,
    "stickPosY": 245.99,
    "word": "usa",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/usa.png"
  },
  {
    "stickPosX": 534.75,
    "stickPosY": 136,
    "word": "jabón",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/jabon.png"
  },
  {
    "stickPosX": 495.55,
    "stickPosY": 212,
    "word": "íntimo",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/intimo.png"
  },
  {
    "stickPosX": 1176.54,
    "stickPosY": 263.99,
    "word": "y",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/y.png"
  },
  {
    "stickPosX": 886.5,
    "stickPosY": 423,
    "word": "mantén",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/manten.png"
  },
  {
    "stickPosX": 482.45,
    "stickPosY": 301,
    "word": "balanceado",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/balanceado.png"
  },
  {
    "stickPosX": 70.5,
    "stickPosY": 251,
    "word": "el",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/el.png"
  },
  {
    "stickPosX": 256.46,
    "stickPosY": 372.49,
    "word": "ph",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/ph.png"
  },
  {
    "stickPosX": 1029.52,
    "stickPosY": 519,
    "word": "de",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/de.png"
  },
  {
    "stickPosX": 243.56,
    "stickPosY": 191.62,
    "word": "tu",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/tu.png"
  },
  {
    "stickPosX": 133.55,
    "stickPosY": 466,
    "word": "zona v",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set2/zonav.png"
  }
]
  .map((data) => new WordData(data));

//// VERSION 3 USA PAÑITOS HÚMEDOS NOSOTRAS PARA MANTENERTE LIMPIA TODO EL DÍA

export const WORD_LIST_3 = [
  {
    "stickPosX": 871.83,
    "stickPosY": 357.25,
    "word": argentis ? 'usá' : "usa",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + `/set3/${argentis ? 'usa_arg' : 'usa'}.png`
  },
  {
    "stickPosX": 133.52,
    "stickPosY": 383,
    "word": "pañitos",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/panitos.png"
  },
  {
    "stickPosX": 1194.39,
    "stickPosY": 434.87,
    "word": "húmedos",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/humedos.png"
  },
  {
    "stickPosX": 227.5,
    "stickPosY": 152.78,
    "word": "nosotras",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/nosotras.png"
  },
  {
    "stickPosX": 974.85,
    "stickPosY": 482.57,
    "word": "para",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/para.png"
  },
  {
    "stickPosX": 1079.5,
    "stickPosY": 261,
    "word": "mantenerte",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/mantenerte.png"
  },
  {
    "stickPosX": 368.5,
    "stickPosY": 283,
    "word": "limpia",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/limpia.png"
  },
  {
    "stickPosX": 969.1,
    "stickPosY": 193.41,
    "word": "todo",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/todo.png"
  },
  {
    "stickPosX": 110.5,
    "stickPosY": 261,
    "word": "el",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/el.png"
  },
  {
    "stickPosX": 275.27,
    "stickPosY": 394,
    "word": "día",
    "isLocked": false,
    "stickSrc": ASSETS_BASE_URL + "/set3/dia.png"
  }
]
  .map((data) => new WordData(data));